module.exports = __webpack_public_path__ + "static/media/mp-empty-list-icon.1d29c189.svg";